import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <Helmet>
        <title>404 — Page non trouvée | Lacrea</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="text-center max-w-md">
        <motion.span
          className="inline-block text-8xl mb-6"
          animate={{ rotate: [0, 10, -10, 0], y: [0, -10, 0] }}
          transition={{ duration: 3, repeat: Infinity }}
        >
          🔍
        </motion.span>
        <h1
          className="text-6xl font-bold mb-4 text-foreground"
        >
          404
        </h1>
        <p className="text-xl text-muted-foreground mb-8">
          Cette page n'existe pas ou a été déplacée.
        </p>
        <Link to="/">
          <Button className="rounded-full bg-primary hover:bg-primary/90 px-8 py-6 text-lg font-semibold">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
